import { render } from "./MantenedorHabilidades.vue?vue&type=template&id=35331942"
import script from "./MantenedorHabilidades.vue?vue&type=script&lang=js"
export * from "./MantenedorHabilidades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__